import {
  ICertMasterPlatformAccessKeyRedemption,
  IError,
  IQueryHookOptions,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { redeemCertMasterPlatformAccessKey } from 'services';

type RedeemAccessKeyFunction = UseMutateAsyncFunction<
  ICertMasterPlatformAccessKeyRedemption,
  IError,
  string
>;

type UseRedeemAccessKey = [RedeemAccessKeyFunction, IQueryHookOptions];

export const useCertMasterPlatformRedeemAccessKey = (
  id = '',
): UseRedeemAccessKey => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    ICertMasterPlatformAccessKeyRedemption,
    IError,
    string
  >(
    (key: string) =>
      redeemCertMasterPlatformAccessKey({ accessKey: key, userId: id }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['profile', 'entitlements']);
      },
    },
  );

  return [mutateAsync, { error, isError, isLoading }];
};
